/* Table-finder capture v2.
 *
 * Rewrites the capture card that sections/wmd-table-finder.liquid renders, instead of
 * editing that section: the finder keeps owning WHEN the card is shown (its own
 * updateCapture() still toggles #wmd-finder-capture), this file owns WHAT it asks for.
 * Replacing the inner markup also removes v1's form together with its submit listener.
 *
 * What changed against v1, and why:
 *   - Channel first, one tap. WhatsApp reads better on a phone, email on a desktop, so the
 *     buttons swap order by viewport instead of forcing one channel on everyone.
 *   - The reward is named before the ask. v1 asked for an address and promised the results
 *     the visitor was already looking at; the discount was invisible until after signup.
 *   - WhatsApp path asks for no checkbox at all — the message itself is the consent.
 *   - Email path keeps exactly one checkbox, because Shopify cannot send to a customer who
 *     is not subscribed. That is the honest reason, so the copy says it.
 *   - Top matches are read out of the rendered results grid at the moment of the tap, so a
 *     later filter change cannot rewrite what was sent.
 */
(function () {
  if (window.__wmdFinderCapture) return;
  window.__wmdFinderCapture = true;

  var cfg = null;
  var built = false;

  function config() {
    if (cfg) return cfg;
    var el = document.getElementById('wmd-finder-capture-config');
    if (!el) return null;
    try {
      cfg = JSON.parse(el.textContent);
    } catch (err) {
      console.error('[wmd-finder-capture] config JSON invalid — capture card left as it was.', err);
      return null;
    }
    return cfg;
  }

  function topMatches(limit) {
    var cards = document.querySelectorAll('#wmd-finder-results .wmd-finder__card');
    var out = [];
    for (var i = 0; i < cards.length && out.length < limit; i++) {
      var card = cards[i];
      if (card.classList.contains('is-sold')) continue;
      var titleEl = card.querySelector('.wmd-finder__card-title');
      var href = card.getAttribute('href') || '';
      out.push({
        title: titleEl ? titleEl.textContent.trim() : '',
        href: href,
        handle: (href.split('/products/')[1] || '').split('?')[0]
      });
    }
    return out;
  }

  function hasUnikat() {
    return !!document.querySelector('#wmd-finder-results .wmd-finder__badge:not(.wmd-finder__badge--sold)');
  }

  function tagsFor(matches) {
    var tags = ['finder', 'finder-lead'];

    document.querySelectorAll('.wmd-finder__options[data-group] .wmd-finder__option.is-active').forEach(function (btn) {
      var group = btn.closest('.wmd-finder__options').getAttribute('data-group');
      var value = btn.getAttribute('data-value');
      if (!value || value === 'any' || group === 'size') return;
      if (group === 'wood') tags.push('finder-holz-' + value);
      if (group === 'shape') tags.push('finder-form-' + value);
      if (group === 'style') tags.push('finder-stil-' + value);
    });

    matches.forEach(function (m) {
      if (m.handle) tags.push('fp-' + m.handle);
    });

    if (matches.length) {
      var first = matches[0].title.toLowerCase();
      if (first.indexOf('mango') !== -1) tags.push('fw-mango');
      else if (first.indexOf('akazie') !== -1 || first.indexOf('acacia') !== -1) tags.push('fw-akazie');
    }

    return tags;
  }

  function markDone() {
    try { localStorage.setItem('wmd_finder_capture_done', '1'); } catch (err) { /* fail open */ }
  }

  function showSuccess(inner, c, channel) {
    /* WhatsApp does not put anything in an inbox — saying so would be a small lie the
       visitor can check in two seconds. */
    inner.innerHTML = '';
    var h = document.createElement('h3');
    h.textContent = channel === 'wa' ? c.okHeadingWa : c.okHeading;
    var p = document.createElement('p');
    p.textContent = channel === 'wa' ? c.okBodyWa : c.okBody;
    inner.appendChild(h);
    inner.appendChild(p);
  }

  function sendWhatsApp(c) {
    var matches = topMatches(3);
    var lines = [c.waIntro];

    matches.forEach(function (m, i) {
      var url = m.href.indexOf('http') === 0 ? m.href : (c.origin || '') + m.href;
      lines.push((i + 1) + ') ' + m.title + ' — ' + url);
    });

    lines.push(c.waOutro);

    var url = 'https://wa.me/' + c.waNumber + '?text=' + encodeURIComponent(lines.join('\n'));
    window.open(url, '_blank', 'noopener');
  }

  function sendEmail(c, email, consent) {
    var matches = topMatches(3);
    var body = new URLSearchParams();

    body.set('form_type', 'customer');
    body.set('utf8', '✓');
    body.set('contact[email]', email);
    body.set('contact[accepts_marketing]', consent ? '1' : '0');
    body.set('contact[tags]', tagsFor(matches).join(', '));

    return fetch('/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString()
    });
  }

  function build() {
    if (built) return;

    var c = config();
    var inner = document.getElementById('wmd-finder-capture-inner');
    if (!c || !inner) return;

    built = true;
    inner.innerHTML = '';
    inner.classList.add('wmd-capture2');

    var h = document.createElement('h3');
    h.textContent = c.heading;

    var sub = document.createElement('p');
    sub.textContent = c.sub;

    inner.appendChild(h);
    inner.appendChild(sub);

    if (hasUnikat()) {
      var scarce = document.createElement('p');
      scarce.className = 'wmd-capture2__scarcity';
      scarce.textContent = c.scarcity;
      inner.appendChild(scarce);
    }

    var row = document.createElement('div');
    row.className = 'wmd-capture2__row';

    var waBtn = document.createElement('button');
    waBtn.type = 'button';
    waBtn.className = 'wmd-capture2__btn wmd-capture2__btn--wa';
    waBtn.textContent = c.whatsapp;

    var mailBtn = document.createElement('button');
    mailBtn.type = 'button';
    mailBtn.className = 'wmd-capture2__btn wmd-capture2__btn--mail';
    mailBtn.textContent = c.mail;

    var skipBtn = document.createElement('button');
    skipBtn.type = 'button';
    skipBtn.className = 'wmd-finder__link wmd-capture2__skip';
    skipBtn.textContent = c.skip;

    row.appendChild(waBtn);
    row.appendChild(mailBtn);
    row.appendChild(skipBtn);
    inner.appendChild(row);

    /* Email step stays closed until asked for: one tap is the whole ask up to here. */
    var mailStep = document.createElement('div');
    mailStep.className = 'wmd-capture2__mail';
    mailStep.hidden = true;

    var input = document.createElement('input');
    input.type = 'email';
    input.className = 'wmd-finder__capture-input';
    input.placeholder = c.mailPlaceholder;
    input.autocomplete = 'email';

    var consentLabel = document.createElement('label');
    consentLabel.className = 'wmd-finder__capture-consent';
    var consentBox = document.createElement('input');
    consentBox.type = 'checkbox';
    var consentText = document.createElement('span');
    consentText.textContent = c.consent;
    consentLabel.appendChild(consentBox);
    consentLabel.appendChild(consentText);

    var goBtn = document.createElement('button');
    goBtn.type = 'button';
    goBtn.className = 'wmd-capture2__btn wmd-capture2__btn--go';
    goBtn.textContent = c.mailSubmit;

    var msg = document.createElement('p');
    msg.className = 'wmd-finder__capture-msg';
    msg.hidden = true;

    mailStep.appendChild(input);
    mailStep.appendChild(consentLabel);
    mailStep.appendChild(goBtn);
    mailStep.appendChild(msg);
    inner.appendChild(mailStep);

    waBtn.addEventListener('click', function () {
      sendWhatsApp(c);
      markDone();
      showSuccess(inner, c, 'wa');
    });

    mailBtn.addEventListener('click', function () {
      mailStep.hidden = false;
      input.focus();
    });

    skipBtn.addEventListener('click', function () {
      var card = document.getElementById('wmd-finder-capture');
      if (card) card.hidden = true;
    });

    goBtn.addEventListener('click', function () {
      var email = input.value.trim();

      if (!email || email.indexOf('@') === -1 || !consentBox.checked) {
        msg.hidden = false;
        msg.textContent = c.error;
        return;
      }

      sendEmail(c, email, true)
        .then(function () {
          markDone();
          showSuccess(inner, c);
        })
        .catch(function () {
          msg.hidden = false;
          msg.textContent = c.error;
        });
    });
  }

  function init() {
    build();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* The finder renders its results after its own script runs; the card can appear later. */
  document.addEventListener('shopify:section:load', function () {
    built = false;
    build();
  });
})();
